import { j as i } from "../../jsx-runtime-B6kdoens.js";
import { useMemo as l } from "react";
import { c as g } from "../../index-CROKJrb5.js";
import { c as f, f as b } from "../../create-component-CBAeEoQ6.js";
import { Typography as c } from "../Typography/index.js";
const x = g({
  base: "cur-flex cur-flex-col cur-self-start",
  variants: {
    tileType: {
      brand: "cur-p-3 cur-bg-surface-brand-light",
      highlight: "cur-bg-surface-brand-accent"
    },
    size: {
      sm: null,
      lg: null
    }
  },
  compoundVariants: [
    {
      size: "lg",
      tileType: "highlight",
      className: "cur-px-4 cur-py-3"
    },
    {
      size: "sm",
      tileType: "highlight",
      className: "cur-px-1 cur-py-[0.125rem]"
    }
  ]
}), T = ({
  size: r,
  tileType: e
}) => l(() => e === "brand" ? r === "lg" ? "d1" : "d2" : r === "lg" ? "subhead" : "meta", [r, e]), j = ({
  size: r
}) => l(() => [
  r === "sm" ? "meta" : "subhead",
  r === "sm" ? "normal" : "bold"
], [r]), S = f(
  "Tile",
  b(
    ({
      as: r,
      className: e,
      description: n,
      size: s = "lg",
      tileType: t = "brand",
      tileTitle: o,
      ...a
    }, m) => {
      const u = r || "div", p = T({
        size: s,
        tileType: t
      }), [d, h] = j({
        size: s
      });
      return /* @__PURE__ */ i.jsxs(
        u,
        {
          ref: m,
          className: x({ className: e, size: s, tileType: t }),
          ...a,
          children: [
            /* @__PURE__ */ i.jsx(c, { size: p, weight: "bold", children: o }),
            t === "brand" ? /* @__PURE__ */ i.jsx(c, { size: d, weight: h, children: n }) : null
          ]
        }
      );
    }
  )
);
export {
  S as Tile
};
//# sourceMappingURL=index.js.map
